import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M15 10.001h1v1h-1v-1zM15 8.001h1v1h-1v-1zM15 12.001h1v1h-1v-1zM15 14.001h1v1h-1v-1zM9 6h1v1H9V6zM7 6h1v1H7V6zM5 6h1v1H5V6zM11 6h1v1h-1V6zM9 8h1v1H9V8zM7 8h1v1H7V8zM5 8h1v1H5V8zM11 8h1v1h-1V8zM9 10h1v1H9v-1zM7 10h1v1H7v-1zM5 10h1v1H5v-1zM11 10h1v1h-1v-1zM9 12h1v1H9v-1zM7 12h1v1H7v-1zM5 12h1v1H5v-1zM11 12h1v1h-1v-1zM9 14h1v1H9v-1zM7 14h1v1H7v-1zM5 14h1v1H5v-1zM11 14h1v1h-1v-1z',
    'M19 19.001v-1h-1V8c0-.713-2.541-2.847-4-3V2c0-.717-.742-.995-1.84-.995C9.029 1.005 3 3.259 3 4v14l-1 .017V19l17 .001zm-15-.984V4.357c1.058-.704 5.598-2.351 8.16-2.351.483 0 .73.063.84.104v15.891l-9 .016zM17 18h-3V6c.889.165 2.656 1.409 3 2v10z',
  ],
  height: 20,
  width: 20,
});
